"use client";

import { c as _c } from "react/compiler-runtime";
import { EASE_OUT_QUART } from "@/lib/animation-constants";
import { motion } from "motion/react";
const ASSETS = "/templates/hero";
const RECT_LEFT = ["rect-a", "rect-b", "rect-c", "rect-a"] as const;
const RECT_RIGHT = ["rect-d", "rect-e", "rect-f", "rect-d"] as const;
const DOT_CLUSTER: ReadonlyArray<[number, number]> = [[5, 0], [9.37, 0], [13.75, 0], [13.75, 9.38], [0, 14.38], [4.38, 14.38], [28.13, 9.38], [28.13, 14.38], [28.13, 18.75], [23.75, 18.75], [18.75, 18.75], [18.75, 23.75], [28.13, 23.75]];
const GRID_DECORATION_OFFSETS = {
  left: {
    vlineLeft: 150.33,
    squareLeft: 148,
    barsLeft: 127,
    barsAlign: "items-end",
    dotsLeft: 167.51
  },
  right: {
    vlineLeft: 155.51,
    squareLeft: 150.51,
    barsLeft: 147,
    barsAlign: "items-start",
    dotsLeft: 193.98
  }
} as const;
function RectGrid(t0) {
  const $ = _c(4);
  const {
    rects
  } = t0;
  let t1;
  if ($[0] !== rects) {
    t1 = rects.map(_temp);
    $[0] = rects;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="relative flex shrink-0 items-center pr-px">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(name, i) {
  return <img key={i} src={`${ASSETS}/${name}.svg`} alt="" aria-hidden="true" className="-mr-px block size-[82px] shrink-0" />;
}
function GridDecoration(t0) {
  const $ = _c(21);
  const {
    side
  } = t0;
  const o = GRID_DECORATION_OFFSETS[side];
  const t1 = `${o.vlineLeft}px`;
  let t2;
  if ($[0] !== t1) {
    t2 = <img src={`${ASSETS}/vec-vline.svg`} alt="" aria-hidden="true" className="pointer-events-none absolute top-[41px] h-[99px] w-[5.33px]" style={{
      left: t1
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${o.squareLeft}px`;
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="bg-ds-surface-primary border-ds-border pointer-events-none absolute top-[140px] size-[10px] border" style={{
      left: t3
    }} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `pointer-events-none absolute top-[89px] flex flex-col gap-[2px] ${o.barsAlign}`;
  const t6 = `${o.barsLeft}px`;
  let t7;
  if ($[4] !== t6) {
    t7 = {
      left: t6
    };
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="bg-ds-border-default h-[2px] w-[21px]" />;
    t9 = <div className="bg-ds-border-default h-[2px] w-[11px]" />;
    $[6] = t8;
    $[7] = t9;
  } else {
    t8 = $[6];
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t5 || $[9] !== t7) {
    t10 = <div className={t5} style={t7}>{t8}{t9}</div>;
    $[8] = t5;
    $[9] = t7;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = `${o.dotsLeft}px`;
  let t12;
  if ($[11] !== t11) {
    t12 = {
      left: t11
    };
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = DOT_CLUSTER.map(_temp2);
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t12) {
    t14 = <div className="pointer-events-none absolute top-[113px]" style={t12}>{t13}</div>;
    $[14] = t12;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t10 || $[17] !== t14 || $[18] !== t2 || $[19] !== t4) {
    t15 = <>{t2}{t4}{t10}{t14}</>;
    $[16] = t10;
    $[17] = t14;
    $[18] = t2;
    $[19] = t4;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
}
function _temp2(t0, i) {
  const [x, y] = t0;
  return <div key={i} className="bg-ds-border-default absolute size-[1.875px]" style={{
    left: `${x}px`,
    top: `${y}px`
  }} />;
}
export function TemplateHero(t0) {
  const $ = _c(25);
  const {
    flush: t1
  } = t0 === undefined ? {} : t0;
  const flush = t1 === undefined ? false : t1;
  const t2 = flush ? "w-full" : "mx-auto w-full max-w-[1300px] px-4 pt-4 md:pt-10";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      boxShadow: "0px 1px 2px 0px rgba(23,22,25,0.05)"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["-translate-y-[60px]", "-translate-y-1/2", "translate-y-[60px]"].map(_temp3);
    t5 = <img src={`${ASSETS}/vec-arc-left.svg`} alt="" aria-hidden="true" className="pointer-events-none absolute left-[50px] top-0 h-[51px] w-[302px] rotate-180 dark:opacity-30" />;
    t6 = <img src={`${ASSETS}/vec-arc-right.svg`} alt="" aria-hidden="true" className="pointer-events-none absolute bottom-0 right-[50px] h-[51px] w-[302px] dark:opacity-30" />;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t4 = $[1];
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="pointer-events-none absolute -left-[128px] -top-[111px] flex size-[260px] items-center justify-center"><div className="border-ds-border size-[184px] -rotate-45 border border-dashed" /></div>;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t10;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pointer-events-none absolute -right-[128px] top-1/2 mt-[41px] flex size-[260px] -translate-y-1/2 items-center justify-center"><div className="border-ds-border size-[184px] -rotate-45 border border-dashed" /></div>;
    t9 = <img src={`${ASSETS}/dots.svg`} alt="" aria-hidden="true" className="pointer-events-none absolute -left-[222px] -top-[20px] h-1 w-[334px] rotate-180 dark:opacity-30" />;
    t10 = <img src={`${ASSETS}/dots.svg`} alt="" aria-hidden="true" className="pointer-events-none absolute -top-[20px] left-[919px] h-1 w-[334px] dark:opacity-30" />;
    $[5] = t10;
    $[6] = t8;
    $[7] = t9;
  } else {
    t10 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t11;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <img src={`${ASSETS}/corner-marker.svg`} alt="" aria-hidden="true" className="size-[8px] rotate-180" />;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="relative hidden items-start gap-[2px] md:flex">{t11}<div className="relative"><RectGrid rects={RECT_LEFT} /><div className="border-ds-border-default absolute -top-[11px] left-0 size-[8px] border" /><div className="border-ds-border-default absolute -bottom-[11px] left-0 size-[8px] border" /></div><GridDecoration side="left" /></div>;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  let t14;
  let t15;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      opacity: 0,
      scale: 0.92
    };
    t14 = {
      opacity: 1,
      scale: 1
    };
    t15 = {
      duration: 0.7,
      ease: EASE_OUT_QUART
    };
    $[10] = t13;
    $[11] = t14;
    $[12] = t15;
  } else {
    t13 = $[10];
    t14 = $[11];
    t15 = $[12];
  }
  let t16;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="pointer-events-none absolute -top-[3px] left-1/2 z-30 flex -translate-x-1/2 items-center">{[0, 1, 2].map(_temp4)}</div>;
    $[13] = t16;
  } else {
    t16 = $[13];
  }
  let t17;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      className: "-right-[4px] top-1/2 -translate-y-1/2"
    };
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      className: "-right-[3.5px]",
      style: {
        top: "calc(50% + 9.5px)",
        transform: "translateY(-50%)"
      }
    };
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  let t19;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      className: "-left-[3.5px]",
      style: {
        top: "calc(50% - 9px)",
        transform: "translateY(-50%)"
      }
    };
    $[16] = t19;
  } else {
    t19 = $[16];
  }
  let t20;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [t17, t18, t19, {
      className: "-left-[3.5px]",
      style: {
        top: "calc(50% + 0.5px)",
        transform: "translateY(-50%)"
      }
    }];
    $[17] = t20;
  } else {
    t20 = $[17];
  }
  let t21;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = (t20 as const).map(_temp5);
    $[18] = t21;
  } else {
    t21 = $[18];
  }
  let t22;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <motion.div initial={t13} animate={t14} transition={t15} className="relative">{t16}<div className="border-ds-border bg-ds-surface-card rounded-ds-30 relative z-10 flex items-center gap-2 border p-1.5 md:rounded-full md:p-[10px]">{t21}<div className="border-ds-border bg-ds-surface-card rounded-ds-26 flex h-[58px] items-center justify-center border px-5 md:h-[100px] md:rounded-full md:px-16" style={{
          boxShadow: "0px 12px 16px 0px rgba(0,0,0,0.08), 0px 4px 6px 0px rgba(0,0,0,0.03), 0px 2px 2px 0px rgba(0,0,0,0.04)"
        }}><p aria-hidden="true" className="text-ds-text-subtle leading-label whitespace-nowrap text-3xl font-medium md:text-5xl md:tracking-[-0.96px]">Template Library</p></div></div></motion.div>;
    $[19] = t22;
  } else {
    t22 = $[19];
  }
  let t23;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <img src={`${ASSETS}/corner-marker.svg`} alt="" aria-hidden="true" className="size-[8px]" />;
    $[20] = t23;
  } else {
    t23 = $[20];
  }
  let t24;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="relative flex items-center justify-center gap-4">{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t12}{t22}<div className="relative hidden items-start gap-[2px] md:flex">{t23}<div className="relative"><RectGrid rects={RECT_RIGHT} /><div className="border-ds-border-default absolute -top-[11px] left-0 size-[8px] border" /></div><GridDecoration side="right" /><img src={`${ASSETS}/group4.svg`} alt="" aria-hidden="true" className="pointer-events-none absolute -top-[68px] right-[60px] size-[40px] dark:opacity-30" /></div></div>;
    $[21] = t24;
  } else {
    t24 = $[21];
  }
  let t25;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="rounded-ds-2xl border-ds-border bg-ds-surface-card relative overflow-hidden border p-2.5" style={t3}><div className="rounded-ds-14 bg-ds-surface-primary relative flex flex-col items-center gap-6 overflow-hidden py-12">{t24}<motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3,
          ease: EASE_OUT_QUART
        }} className="text-ds-text-subtle relative z-10 max-w-[475px] px-4 text-center text-lg leading-7">Ready-to-use workflow templates to automate your crypto operations. Fork one and launch in minutes.</motion.p><div className="from-ds-surface-primary pointer-events-none absolute inset-y-0 left-0 w-[116px] bg-gradient-to-r via-white/80 to-transparent dark:via-zinc-950/80" /><div className="from-ds-surface-primary pointer-events-none absolute inset-y-0 right-0 w-[116px] bg-gradient-to-l via-white/80 to-transparent dark:via-zinc-950/80" /><div className="from-ds-surface-primary pointer-events-none absolute inset-x-0 top-0 h-8 bg-gradient-to-b to-transparent" /><div className="from-ds-surface-primary pointer-events-none absolute inset-x-0 bottom-0 h-8 bg-gradient-to-t to-transparent" /></div></div>;
    $[22] = t25;
  } else {
    t25 = $[22];
  }
  let t26;
  if ($[23] !== t2) {
    t26 = <div className={t2}>{t25}</div>;
    $[23] = t2;
    $[24] = t26;
  } else {
    t26 = $[24];
  }
  return t26;
}
function _temp5(m, i_0) {
  return <img key={i_0} src={`${ASSETS}/frame-86.svg`} alt="" aria-hidden="true" className={`pointer-events-none absolute size-[7px] ${m.className}`} style={"style" in m ? m.style : undefined} />;
}
function _temp4(i) {
  return <img key={i} src={`${ASSETS}/frame-87.svg`} alt="" aria-hidden="true" className="block h-[52.5px] w-[7px]" style={{
    marginTop: "-45.5px"
  }} />;
}
function _temp3(yClass) {
  return <img key={yClass} src={`${ASSETS}/line-h.svg`} alt="" aria-hidden="true" className={`pointer-events-none absolute left-1/2 top-1/2 h-px w-[1200px] -translate-x-1/2 dark:opacity-30 ${yClass}`} />;
}